import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useSearchParams,useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Row, Col, Container, Spinner } from 'react-bootstrap';
import copy from "copy-to-clipboard";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SATextArea from "../components/SATextArea";
import BottomNavBar from "../components/BottomNavBar";
import SATextInput from "../components/SATextInput";
import StepAway from "../components/StepAway";
import * as collegeOrUniversityAPI from "../services/collegeUniversity";
import toast, { toastConfig } from 'react-simple-toasts';

export default function CollegeUniversity() {
    const navigate = useNavigate();
    const location = useLocation();
    let [searchParams] = useSearchParams();
    
    const [loader, setLoader] = useState(false)
    const [copyUrl, setCopyUrl] = useState('');
    const [studHCode, setHexCode] = useState('');

    toastConfig({
        render: message => <div style={{ backgroundColor: '#cc2427', color: 'white', padding: 10, borderRadius: 10, fontSize: 18, fontWeight: '700' }}>{message}</div>,
    })


    useEffect(() => {
        document.title = 'College or University Considering | Families of WWII Vetearnas';
        window.scrollTo({ top: 0, behaviour: "smooth" })
    }, []);

    useEffect(() => {
       let hexCode =location?.state?.hexCode? location.state.hexCode : "";
        if(hexCode === ""){
            hexCode = searchParams.get("code");
        }
        setHexCode(hexCode);
        let modifiedURL = window.location.href.search("code")
        let url = ""
        if (modifiedURL > -1) {
            url = `${window.location.href}`
        } else {

            url = `${window.location.href}?code=${hexCode}`
        }
        setCopyUrl(url)
        
    }, [location?.state?.hexCode,searchParams]);

    

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: {
            college1: '',
            college2: '',
            college3: '',
            college4: '',
            college5: '',
            college6: '',
            college7: '',
            college8: '',
            academicConcentration: '',
            specialConsideration: '',
        }
    })

    const getCollegeUniverityApi = useCallback(async () => {
        setLoader(true)
        try {
            await collegeOrUniversityAPI.getCollegeInformation(`student/${studHCode}/college`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    let collUnivData = res.data;
                    reset({
                        college1: collUnivData.college1,
                        college2: collUnivData.college2,
                        college3: collUnivData.college3,
                        college4: collUnivData.college4,
                        college5: collUnivData.college5,
                        college6: collUnivData.college6,
                        college7: collUnivData.college7,
                        college8: collUnivData.college8,
                        academicConcentration: collUnivData.possibleAreas,
                        specialConsideration: collUnivData.specialConsideration,
                    })
                }else {
                    if(res.status === 204){
                        return 
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }
    }, [reset,studHCode])

    useEffect(() => {
        if (studHCode) {
            getCollegeUniverityApi()
        } 
    }, [getCollegeUniverityApi,studHCode]);
    const handleBack = () => {
        navigate("/family",{
            state:{hexCode : studHCode}
        })
    }
    const handleNavBack = (to) => {
        navigate(to,{
            state:{hexCode : studHCode}
        })
    }
    const onSubmit = async (data) => {
        let clgOrUnivObj = {

            "college1": data.college1,
            "college2": data.college2,
            "college3": data.college3,
            "college4": data.college4,
            "college5": data.college5,
            "college6": data.college6,
            "college7": data.college7,
            "college8": data.college8,
            "possibleAreas": data.academicConcentration,
            "specialConsideration": data.specialConsideration,
        }
        setLoader(true)
        try {
            await collegeOrUniversityAPI.postCollegeInformation(clgOrUnivObj, `student/${studHCode}/college`).then((res) => {
               
                if (res.status === 200) {
                    navigate("/work-activities",{
                        state:{hexCode : studHCode}
                    })
                } else if (res.status === 422) {
                    let errorData = res?.data?.errors
                    if (Object.keys(errorData) && Object.keys(errorData).length > 0) {
                        Object.keys(errorData).forEach((err, index) => {
                            toast(errorData[err][0], { position: 'top-right', backgroundColor: 'red' })
                        })
                    }
                } else {
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })  
        }
    }
    const handleCopy = () => {
        copy(copyUrl);
        alert(`URLGOESHERE copied to your clipboard. Save this URL.`);
    }
    return (
        <>
            <Header title="Scholarship Application" />
            {loader && <div lg={12} md={12} sm={12} className="loaderContainer">
                <Spinner animation="border" variant="primary" /> </div>}
            <Container className='py-3 py-md-4 py-md-5'>
                <Row>
                    <Col lg={12}>
                        <StepAway handleCopy={handleCopy} copyInputValue={copyUrl} />
                        <Nav navbType="student" handleNavBack={handleNavBack}/>
                        <form onSubmit={handleSubmit(onSubmit)} >

                            <Row>
                                <Col lg={6}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={"college1"}
                                        name={"college1"}
                                        label={"College 1:"}
                                        isStrong={true}
                                        requiredText={"College 1 is required!"}
                                        type={"text"}
                                        placeholder={"College 1 (required)"}
                                        errors={errors}
                                        id={"college1Help"}
                                        maxLength={100}
                                        errMsg={errors.college1?.message}
                                        requiredObj={{
                                            required: "College 1 is required!",
                                            pattern: {
                                                value: /[\sa-zA-Z'`~.s -]+$/, message: "Invalid College1!"
                                            }
                                        }}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={"college2"}
                                        name={"college2"}
                                        label={"College 2:"}
                                        isStrong={false}
                                        type={"text"}
                                        placeholder={"College 2"}
                                        errors={errors}
                                        id={"college2Help"}
                                        maxLength={100}

                                    />
                                </Col>

                                <Col lg={6}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={"college3"}
                                        name={"college3"}
                                        label={"College 3:"}
                                        isStrong={false}
                                        type={"text"}
                                        placeholder={"College 3"}
                                        errors={errors}
                                        id={"college3Help"}
                                        maxLength={100}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={"college4"}
                                        name={"college4"}
                                        label={"College 4:"}
                                        isStrong={false}
                                        type={"text"}
                                        placeholder={"College 4"}
                                        errors={errors}
                                        id={"college4Help"}
                                        maxLength={100}
                                    />
                                </Col>

                                <Col lg={6}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={"college5"}
                                        name={"college5"}
                                        label={"College 5:"}
                                        isStrong={false}
                                        type={"text"}
                                        placeholder={"College 5"}
                                        errors={errors}
                                        id={"college5Help"}
                                        maxLength={100}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={"college6"}
                                        name={"college6"}
                                        label={"College 6:"}
                                        isStrong={false}
                                        type={"text"}
                                        placeholder={"College 6"}
                                        errors={errors}
                                        id={"college6Help"}
                                        maxLength={100}
                                    />
                                </Col>

                                <Col lg={6}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={"college7"}
                                        name={"college7"}
                                        label={"College 7:"}
                                        isStrong={false}
                                        type={"text"}
                                        placeholder={"College 7"}
                                        errors={errors}
                                        id={"college3Help"}
                                        maxLength={100}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={"college8"}
                                        name={"college8"}
                                        label={"College 8:"}
                                        isStrong={false}
                                        type={"text"}
                                        placeholder={"College 8"}
                                        errors={errors}
                                        id={"college4Help"}
                                        maxLength={100}
                                    />
                                </Col>

                                <Col lg={12}>
                                    <SATextArea
                                        register={register}
                                        htmlFor={"academicConcentration"}
                                        name={"academicConcentration"}
                                        label={"Possible area(s) of academic concentration/major:"}
                                        isStrong={true}
                                        requiredObj={{
                                            required: "Possible area(s) of academic concentration/major is required!",
                                            maxLength: { value: 400, message: "Max length is 400 characters!" }
                                        }}
                                        placeholder={"Possible area(s) of academic concentration/major (required)"}
                                        maxLength={400}
                                        id={"howDidYouHearHelp"}
                                        errMsg={errors.academicConcentration?.message}
                                    />
                                </Col>

                                <Col lg={12}>
                                    <SATextArea
                                        register={register}
                                        htmlFor={"specialConsideration"}
                                        name={"specialConsideration"}
                                        label={"Special Consideration:"}
                                        isStrong={true}
                                        requiredObj={{
                                            required: "Special Consideration is required!",
                                            maxLength: { value: 400, message: "Max length is 400 characters!" }
                                        }}
                                        placeholder={"Please list unique or compelling reasons that make you a good candidate for this scholarship. (required)"}
                                        maxLength={400}
                                        id={"howDidYouHearHelp"}
                                        errMsg={errors.specialConsideration?.message}
                                    />
                                </Col>
                            </Row>
                            <BottomNavBar
                                handleBack={handleBack}
                                submitButtonTitle="NEXT" />
                        </form >
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}